import type { TFunction } from 'i18next';

import type { FilterDef } from '@nucleus-commerce/admin-kit/index-table';
import type { StockLocation } from '@nucleus-commerce/api-client/admin';

import { locationStatus, type LocationStatus } from './location-columns';

const STATUSES: readonly LocationStatus[] = ['active', 'inactive'];

/** Filters of the stock locations table; `t` is the `inventory` namespace. */
export function locationFilters(t: TFunction): Array<FilterDef<StockLocation>> {
  return [
    {
      key: 'status',
      label: t('locations.columns.status'),
      type: 'enum',
      pinned: true,
      getValue: locationStatus,
      options: STATUSES.map((status) => ({
        value: status,
        label: t(`locations.status.${status}`),
      })),
    },
    {
      key: 'online',
      label: t('locations.columns.online'),
      type: 'boolean',
      pinned: true,
      trueLabel: t('locations.fulfils'),
      falseLabel: t('locations.notFulfils'),
    },
  ];
}
